if (process.browser) {
  window.WebFontLoader = require('webfontloader')
}
